import axios from '@/libs/api.request'
import {genURLParams} from '@/libs/urlparamhelper';

export const getPage = (params, urlParams) => {
  return axios.request({
    url: '/da/datastatistics/getpage' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getBindAll = (params, urlParams) => {
  return axios.request({
    url: '/da/datastatistics/getbindall/' + params.days + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getClientPage = (params, urlParams) => {
  return axios.request({
    url: '/da/datastatistics/getclientpage' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getDataStatistics = (params, urlParams) => {
  return axios.request({
    url: '/da/datastatistics/' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getidsDataStatistics = (params, urlParams) => {
  return axios.request({
    url: '/da/datastatistics/getidspage/' + params.ids + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const carLocation = (params, urlParams) => {
  return axios.request({
    url: '/da/datastatistics/carLocation' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const carLocationProvincial = (params, urlParams) => {
  return axios.request({
    url: '/da/datastatistics/carLocationProvincial/' + params.name + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const operationCondition = (params, urlParams) => {
  return axios.request({
    url: '/da/datastatistics/operationcondition' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

